import React from 'react';
import ToolkitBatchPage from './toolkit/ToolkitBatchPage';
import { sourceRow } from './toolkit/useToolkitBatch';

// Sync › project › Toolkit › HK Details — ported from the desktop's OHIP › HK Details. Each room in a v5 HK_DETAILS
// report gets its housekeeping status in Opera Cloud: occupancy from FO_STATUS (VAC → Vacant, otherwise Occupied) and
// room status from ROOM_STATUS_DESC (toolkit property.js post-hk-status).

const COLUMNS = [
    { key: 'ROOM', label: 'Room' },
    { key: 'TYPE', label: 'Type' },
    { key: 'FLOOR', label: 'Floor' },
    { key: 'FO_STATUS', label: 'FO status' },
    { key: 'HK_OCCUPANCY_STATUS', label: 'Occupancy' },
    { key: 'HK_ROOM_STATUS', label: 'Room status' },
    { key: 'result', label: 'Result' },
];

const request = (row) => ({ area: 'property', op: 'post-hk-status', args: { record: sourceRow(row, ['result']) } });
const SERVER = { screen: 'hk-details', title: 'HK Details', keyOf: (row) => row.ROOM };

const ToolkitHkDetailsPage = () => (
    <ToolkitBatchPage title="HK Details"
        subtitle="Set each room's housekeeping status in Opera Cloud from an Opera v5 HK Details report."
        fileTitle="Opera v5 HK Details report" fileLabel="Choose HK_DETAILS (XML)" accept=".xml,.rep"
        kind="hk-details" columns={COLUMNS} searchKeys={['ROOM', 'TYPE', 'HK_ROOM_STATUS']} exportName="HK_Details"
        request={request} server={SERVER} />
);

export default ToolkitHkDetailsPage;
